import { Component, Input, OnInit } from '@angular/core';
import { getIcon, MobileProduct, Product } from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { savePii } from '@dch/ng-usage';
import { Router } from '@angular/router';

const DEFAULT_SIZE = 6;
const DEFAULT_PAGE = 0;

@Component({
  selector: 'mprd-mobile-selector',
  templateUrl: './mobile-selector.component.html',
})
export class MobileSelectorComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() link: string;
  @Input() mobileProducts: Array<Product>;

  public productsPagination: Array<Product>;
  public selectedMobileProduct: Product;
  pageForm: UntypedFormGroup;
  page = DEFAULT_PAGE;
  destroy: () => void;
  pages!: number[];
  ofNPages: string;
  shouldRedirect = false;

  constructor(
    private translationService: TranslationService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {
    this.productsPagination = this.sliceProductsList(0);
    this.page = 0;
    this.pages = this.mobileProducts
      ? this.fillPages(this.mobileProducts.length)
      : [];
    this.buildOfNPagesTranslation();
    this.pageForm = this.formBuilder.group({
      pageControl: [DEFAULT_PAGE],
    });
  }

  ngOnDestroy(): void {
    if (this.shouldRedirect) {
      const links = this.link.split('#');
      if (links.length > 1) {
        this.router.navigate(['/' + links[0]], { fragment: links[1] });
      } else {
        this.router.navigate(['/' + this.link]);
      }
    }
  }

  selectProduct(product) {
    this.selectedMobileProduct = product;
  }

  fillPages(total: number): number[] {
    return Array(Math.ceil(total / DEFAULT_SIZE))
      .fill(0)
      .map((x, i) => i);
  }

  onPageChange(page: string) {
    this.goToPage(parseInt(page, 10));
  }

  sliceProductsList(page: number) {
    const start = page * DEFAULT_SIZE;
    const end = page * DEFAULT_SIZE + DEFAULT_SIZE;
    return this.mobileProducts ? this.mobileProducts.slice(start, end) : [];
  }

  buildOfNPagesTranslation() {
    this.ofNPages = this.translationService
      .getTranslatedValueFor('mobile.product.selector.deepLink.ofNPages')
      .replace('{0}', this.pages.length);
  }

  close() {
    this.destroy();
  }

  goToNextPage() {
    this.goToPage(this.page + 1);
  }

  goToPreviousPage() {
    this.goToPage(this.page - 1);
  }

  goToPage(page: number) {
    this.page = page;
    this.pageForm = this.formBuilder.group({
      pageControl: [this.page],
    });
    this.productsPagination = this.sliceProductsList(this.page);
  }

  confirm() {
    savePii(this.selectedMobileProduct.accessNumber);
    this.shouldRedirect = true;
    this.destroy();
  }

  getIcon(product: Product): string {
    return getIcon(product);
  }
}
